import React, { useState, createContext, useContext } from 'react';
import Dialog from './Dialog';

// 1. Crear el Contexto
const DialogContext = createContext();

// 2. Crear el Proveedor que envuelve la App
export const DialogProvider = ({ children }) => {
  const [dialogConfig, setDialogConfig] = useState({
    isOpen: false,
    type: 'success', // 'success', 'error', 'confirm'
    title: '',
    message: '',
    onConfirm: () => {},
  });

  const close = () => setDialogConfig({ ...dialogConfig, isOpen: false });

  const showDialog = (config) => {
    setDialogConfig({ ...config, isOpen: true });
  };

  // Funciones simplificadas que usaremos en la app
  const dialogs = {
    showSuccess: (message, title = '¡Éxito! ✨') => {
      showDialog({ type: 'success', title, message });
    },
    showError: (message, title = 'Error 🚨') => {
      showDialog({ type: 'error', title, message });
    },
    showConfirm: (message, onConfirm, title = '¿Estás seguro? 🤔') => {
      showDialog({ type: 'confirm', title, message, onConfirm });
    },
    showConfirmWithPin: (message, onConfirmCallback, title = 'Se requiere PIN 🔑') => {
      showDialog({
        type: 'confirmWithPin', // Un nuevo tipo de diálogo
        title,
        message,
        onConfirm: onConfirmCallback, // El callback que recibirá el PIN
      });
    },
    //solicitar valor para cambiar
    showPrompt: (message, onConfirm, title = 'Datos requeridos') => {
    
      showDialog({
      type: 'prompt', // Nuevo tipo
      title,
      message,
      onConfirm: (inputValue) => {
        if (inputValue && !isNaN(inputValue)) {
          onConfirm(inputValue);
        } else {
          // Opcional: mostrar un error si el precio no es válido
          alert("Por favor, ingresa un precio válido");
        }
      },
    }
  );
  }
  };

  return (
    <DialogContext.Provider value={dialogs}>
      {children}
      <Dialog dialogConfig={dialogConfig} close={close} />
    </DialogContext.Provider>
  );
};

// 3. Hook personalizado para un uso fácil
export const useDialog = () => {
  return useContext(DialogContext);
};